// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-table-container {
  background: #fff;
  border: 1px solid #e8edf3;
  border-radius: 12px;
  overflow-x: auto;
  box-shadow: 0 2px 8px rgba(23, 64, 120, 0.04);
}

table.admin-data-table {
  width: 100%;
  min-width: 760px;
  border-collapse: separate;
  border-spacing: 0;
}

table.admin-data-table th,
table.admin-data-table td {
  padding: 14px 18px;
  text-align: left;
  border-bottom: 1px solid #edf1f5;
  font-size: 13px;
  line-height: 1.4;
  vertical-align: middle;
  white-space: nowrap;
}

table.admin-data-table th {
  background: #f5f8fc;
  color: #174078;
  font-weight: 700;
  letter-spacing: 0.02em;
}

table.admin-data-table td {
  color: #334155;
}

table.admin-data-table tbody tr:last-child td {
  border-bottom: 0;
}

table.admin-data-table tbody tr:hover {
  background: #fbfcfe;
}

table.admin-data-table th:first-child {
  border-top-left-radius: 11px;
}

table.admin-data-table th:last-child {
  border-top-right-radius: 11px;
}

@media (max-width: 768px) {
  table.admin-data-table {
    min-width: 0;
  }

  table.admin-data-table thead {
    display: none;
  }

  table.admin-data-table tr {
    display: block;
    margin: 12px;
    padding: 10px 14px;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
  }

  table.admin-data-table td {
    display: flex;
    justify-content: space-between;
    gap: 16px;
    padding: 10px 0;
    white-space: normal;
  }

  table.admin-data-table td::before {
    flex: 0 0 38%;
    content: attr(data-label);
    color: #64748b;
    font-weight: 600;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/adminTables.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,gBAAgB;EAClB;AACF","sourcesContent":[".admin-table-container {\n  background: #fff;\n  border: 1px solid #e8edf3;\n  border-radius: 12px;\n  overflow-x: auto;\n  box-shadow: 0 2px 8px rgba(23, 64, 120, 0.04);\n}\n\ntable.admin-data-table {\n  width: 100%;\n  min-width: 760px;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n\ntable.admin-data-table th,\ntable.admin-data-table td {\n  padding: 14px 18px;\n  text-align: left;\n  border-bottom: 1px solid #edf1f5;\n  font-size: 13px;\n  line-height: 1.4;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\ntable.admin-data-table th {\n  background: #f5f8fc;\n  color: #174078;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\ntable.admin-data-table td {\n  color: #334155;\n}\n\ntable.admin-data-table tbody tr:last-child td {\n  border-bottom: 0;\n}\n\ntable.admin-data-table tbody tr:hover {\n  background: #fbfcfe;\n}\n\ntable.admin-data-table th:first-child {\n  border-top-left-radius: 11px;\n}\n\ntable.admin-data-table th:last-child {\n  border-top-right-radius: 11px;\n}\n\n@media (max-width: 768px) {\n  table.admin-data-table {\n    min-width: 0;\n  }\n\n  table.admin-data-table thead {\n    display: none;\n  }\n\n  table.admin-data-table tr {\n    display: block;\n    margin: 12px;\n    padding: 10px 14px;\n    border: 1px solid #e5e7eb;\n    border-radius: 10px;\n  }\n\n  table.admin-data-table td {\n    display: flex;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 10px 0;\n    white-space: normal;\n  }\n\n  table.admin-data-table td::before {\n    flex: 0 0 38%;\n    content: attr(data-label);\n    color: #64748b;\n    font-weight: 600;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
